"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DimensionsMonitor = void 0;
const React = require("react");
const react_native_1 = require("react-native");
class DimensionsMonitor extends React.Component {
    constructor(props) {
        super(props);
        this.handleDimensionsChange = ({ window }) => {
            const isDesktop = this.isDesktop(window);
            this.setState({ isDesktop });
            if (this.props.onDimensionChange && isDesktop !== this.state.isDesktop) {
                this.props.onDimensionChange(isDesktop);
            }
        };
        this.isDesktop = (size) => {
            return size.width >= 1024;
        };
        this.state = {
            isDesktop: this.isDesktop(react_native_1.Dimensions.get('window'))
        };
    }
    componentDidMount() {
        react_native_1.Dimensions.addEventListener('change', this.handleDimensionsChange);
    }
    componentWillUnmount() {
        react_native_1.Dimensions.removeEventListener('change', this.handleDimensionsChange);
    }
    render() {
        if (!this.props.children) {
            return null;
        }
        return this.props.children({ isDesktop: this.state.isDesktop });
    }
}
exports.DimensionsMonitor = DimensionsMonitor;
